import { render, staticRenderFns } from "./createinternaluser.vue?vue&type=template&id=ffc69912"
import script from "./createinternaluser.vue?vue&type=script&lang=js"
export * from "./createinternaluser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports